export default [
    {
        path: '/addresses',
        name: 'addresses',
        component: () => import(/* webpackChunkName: "campus-addresses" */ '../pages/AddressList.vue'),
        meta: {
            title: 'ADDRESSES',
            icon: 'mdi-table-search',
            pageTitle: 'Addresses',
            gtm: 'addresses'
        }
    },
    {
        path: '/campus-addresses',
        redirect: '/addresses'
    }
]
